export default {
  title: {
    fontFamily: 'SackersGothicStd, sans-serif'
  },
  preTitle: {
    fontFamily: 'SackersGothicStd, sans-serif',
    margin: '0 0 16px'
  },
  centerSaleTitle: {},
  centerSaleSubtitle: {},
  contentContainerStyles: {
    display: 'flex',
    flexDirection: 'column',
    padding: '24px 16px',
    'screen-large': {
      padding: '32px 112px'
    }
  },
  additionalBackgroundPictureStyles: {
    height: '260px',
    'screen-large': {
      height: '292px'
    }
  }
}
